import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgDialogModule } from '@principle-theorem/ng-shared';
import { IMarketingCampaign } from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';
import {
  CampaignEntrySettingsComponent,
  ICampaignEntryFormData,
} from '../campaign-entry-settings/campaign-entry-settings.component';

export interface ICampaignEntrySettingsDialogRequest {
  campaign: WithRef<IMarketingCampaign>;
}

export interface ICampaignEntrySettingsDialogResponse {
  formData: ICampaignEntryFormData;
}

@Component({
  selector: 'pr-campaign-entry-settings-dialog',
  templateUrl: './campaign-entry-settings-dialog.component.html',
  styleUrl: './campaign-entry-settings-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgDialogModule, CampaignEntrySettingsComponent],
})
export class CampaignEntrySettingsDialogComponent {
  private _dialogRef = inject(
    MatDialogRef<
      CampaignEntrySettingsDialogComponent,
      ICampaignEntrySettingsDialogResponse
    >
  );
  data = inject<ICampaignEntrySettingsDialogRequest>(MAT_DIALOG_DATA);
  formData = signal<ICampaignEntryFormData | undefined>(undefined);

  submit(): void {
    const formData = this.formData();
    if (!formData) {
      return this._dialogRef.close();
    }
    this._dialogRef.close({ formData });
  }
}
